import { CIActionGuard } from 'ccs-ui-components';
import { UseAuthState } from 'ccs-ui-components/dist/components/ciAuthGuard/store/interfaces';
import { REGISTRY_TYPE } from '../../../../../dashboard/constants/CommonConstants';
import { requiredAuthPermission } from '../../../../constants/UserPermissionConstants';

/**
 * @method canEditRegistry
 * @description This function is used to check if the user has permission to edit the registry.
 * @param registryType - The type of registry.
 * @param permissionObject - The permission object.
 * @returns - A boolean value.
 */
export const canEditRegistry = (registryType: string | undefined, permissionObject: UseAuthState) => {
  switch (registryType) {
    case REGISTRY_TYPE.EVENTS:
      return CIActionGuard([requiredAuthPermission.Events.approve, requiredAuthPermission.Events.edit], permissionObject.permission);
    case REGISTRY_TYPE.SERVICE:
      return CIActionGuard([requiredAuthPermission.Services.approve, requiredAuthPermission.Services.edit], permissionObject.permission);
    case REGISTRY_TYPE.JOURNEY:
      return CIActionGuard([requiredAuthPermission.JD.approve, requiredAuthPermission.JD.edit], permissionObject.permission);
    case REGISTRY_TYPE.SOURCE:
      return CIActionGuard([requiredAuthPermission.Sources.approve, requiredAuthPermission.Sources.edit], permissionObject.permission);
    default:
      return false;
  }
};

/**
 * @method canMarkAsInactive
 * @description This function is used to check if the user has permission to make the registry inactive.
 * @param registryType - The type of registry.
 * @param permissionObject - The permission object.
 * @returns - A boolean value.
 */
export const canMarkAsInactive = (registryType: string | undefined, permissionObject: UseAuthState) => {
  switch (registryType) {
    case REGISTRY_TYPE.EVENTS:
      return CIActionGuard([requiredAuthPermission.Events.approve, requiredAuthPermission.Events.edit], permissionObject.permission);
    case REGISTRY_TYPE.SERVICE:
      return CIActionGuard([requiredAuthPermission.Services.approve, requiredAuthPermission.Services.edit], permissionObject.permission);
    case REGISTRY_TYPE.JOURNEY:
      return CIActionGuard([requiredAuthPermission.Admin.view, requiredAuthPermission.Admin.edit, requiredAuthPermission.Maintainence.view, requiredAuthPermission.Maintainence.edit], permissionObject.permission);
    case REGISTRY_TYPE.SOURCE:
      return CIActionGuard([requiredAuthPermission.Sources.approve, requiredAuthPermission.Sources.edit], permissionObject.permission);
    default:
      return false;
  }
};
